module.exports = require('./index.common');



/** WEBPACK FOOTER **
 ** ../~/jshint-loader!./index.js
 **/